// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-wrapper[data-v-47a0a42c]{display:inline-flex;align-items:center;color:#4a4a4a}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
